module.exports = __webpack_public_path__ + "media/images/global/icons/couple-dfc3f81c20023e05b845d740ed71f502.svg";